module.exports = __webpack_public_path__ + "media/images/lb/567-a456ab11f1fb7e6e1d2968f98643c993.svg";